export default __webpack_public_path__ + "media/fre-animation.gif";